export enum ContentStatusErrorIds {
  MISSING_CONTENT = 100,
}

export const ContentErrorIdNames: { [key: number]: string } = {
  [ContentStatusErrorIds.MISSING_CONTENT]: 'MISSING_CONTENT',
};
